import React, { Component } from 'react';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import { fetchPolicies, fetchFilterOptions } from '../actions';
import PlatformIcon from './PlatformIcon';
import MediaPlatform from './forms/MediaPlatform';


import css from './media-platform-drawer.css';

// Material UI Library
import Drawer from 'material-ui/Drawer';
import Avatar from 'material-ui/Avatar';
import { teal300, teal500, teal700 } from '../colors';

const platformStyle = {
  backgroundColor: teal500,
  padding: 20,
  width: 400,
};

const avatarStyle = {
  rowCount: 3,
  margin: 20,
};

const avatarWidth = (platformStyle.width - avatarStyle.margin * 2 * avatarStyle.rowCount - platformStyle.padding) / avatarStyle.rowCount;

class MediaPlatformDrawer extends Component {

  constructor(props) {
    super(props);
    this.state = { platform: Map() };
  }

  componentDidMount() {
    this.props.dispatch(fetchPolicies());
    this.props.dispatch(fetchFilterOptions());
  }

  handleAddPlatform = (id) => {
    this.setState({
      platform: Map({
        mediaPlatformId: id,
        channelsAttributes: List(),
      }),
    });
  };

  handleSavePlatform = (channelsCollection) => {
    this.props.addPlatform({
      mediaPlatformId: this.state.platform.get('mediaPlatformId'),
      channelsAttributes: channelsCollection,
    });
    this.setState({ platform: Map() });
  };

  handleCancelPlatform = () => {
    this.setState({ platform: Map() });
    this.props.toggleDrawer();
  };

  render() {
    if (this.props.isFetching || this.props.mediaPlatformsCount < 1) {
      return <div></div>;
    }

    return (
      <Drawer
        open={this.props.open}
        openSecondary={true}
        width={platformStyle.width}
      >
        {this.state.platform.get('mediaPlatformId')
          ?
          <MediaPlatform
            platform={this.props.mediaPlatforms.filter(platform =>
              platform.get('id') === this.state.platform.get('mediaPlatformId')
            ).first()}
            channelStyles={this.props.channelStyles}
            savePlatform={this.handleSavePlatform}
            cancelPlatform={this.handleCancelPlatform}
          />
          :
          <ul className={css.platformGrid} style={platformStyle}>
            {this.props.mediaPlatforms.map((platform) =>
              <li key={platform.get('id')}>
                <Avatar
                  icon={PlatformIcon(platform.get('slug'), {
                    color: teal700,
                    style: { verticalAlign: 'bottom' },
                  })}
                  size={avatarWidth}
                  backgroundColor={teal300}
                  onTouchTap={this.handleAddPlatform.bind(this, platform.get('id'))}
                />
              </li>
            )}
          </ul>
        }
      </Drawer>
    );
  }
};

function visibilityFilter(store) {
  return store.get('result').map(id =>
    store.get('items').get(`${id}`)
  );
};

// TODO: After changing store to use items instead of
// entities, use the first visibilityFilter
function visibilityFilter2(store) {
  return store.get('result').map(id =>
    store.get('entities').get(`${id}`)
  );
};

function mapStateToProps(state) {
  return {
    policies: visibilityFilter(state.get('policies')),
    mediaPlatforms: visibilityFilter2(state.get('filterOptions').get('mediaPlatforms')),
    mediaPlatformsCount: state.get('filterOptions').get('mediaPlatforms').get('result').size,
    channelStyles: state.get('filterOptions').get('channelStyles'),
    isFetching: state.get('policies').get('isFetching') && state.get('filterOptions').get('isFetching'),
  };
}

export default connect(mapStateToProps)(MediaPlatformDrawer);



/** WEBPACK FOOTER **
 ** ./components/MediaPlatformDrawer.js
 **/